const swymCustomFunctions = {
  'fetchLists': async function(swat){
      return new Promise(async (resolve, reject) => {
          swat.fetchLists({
          callbackFn: lists => resolve(lists),
          errorFn: err => reject(err)
          });
      });
  },
  'fetchListProductsDetails': async function (swat, lid){
      return new Promise(async (resolve, reject) => {
          swat.fetchListCtx(
            { lid: lid },
            listContents => resolve(listContents),
            error => reject(error)
          );
      });
  },
  'createList': async function (swat, listTitle){
      // Fallback to default if title is undefined or empty
      const title = listTitle || window.defaultListTitle || "Your Pantry Picks";
      console.log('creating list:', title);
      let listConfig = { "lname": title };
      return new Promise(async (resolve, reject) => {
          swat.createList(listConfig,
              list => resolve(list),
              error => reject(error)
          )
      })
  },
  'renameList': function(swat, lid, listTitle) {
      const listUpdateConfig = {
          "lname": listTitle,
          "lid": lid
      }
      return new Promise(async (resolve, reject) => {
          swat.updateList(listUpdateConfig,
              list => resolve(list),
              error => reject(error)
          );
      })
  },
  'deleteLists': async function (swat, lists) {
      try {
          await Promise.all(lists.map(list =>
              new Promise((resolve, reject) => {
                  swat.deleteList(
                      list.lid,
                      obj => resolve(obj),
                      error => reject(error)
                  );
              })
          ));
          return 'All lists deleted successfully';
      } catch (error) {
          console.error('Error encountered while deleting the list', error);
          throw error;
      }
  },
  'addProductsToList': async function (swat, products, lid){
      // Add many products to a list in batches of 10 (API limitation)
      // API reference: https://developers.getswym.com/docs/add-many-products-to-a-list
      if (!products || products.length === 0) {
          return [];
      }
      
      const BATCH_SIZE = 10;
      const batches = [];
      
      // Split products into batches of 10
      for (let i = 0; i < products.length; i += BATCH_SIZE) {
          batches.push(products.slice(i, i + BATCH_SIZE));
      }
      
      // Process batches sequentially to avoid overwhelming the API
      const results = [];
      for (const batch of batches) {
          try {
              const result = await new Promise((resolve, reject) => {
                  swat.addProductsToList(
                      lid,
                      batch,
                      result => resolve(result),
                      error => reject(error)
                  );
              });
              results.push(result);
          } catch (error) {
              console.error('Error adding batch of products to list:', error);
              throw error;
          }
      }
      
      return results.flat();
  },
  'updateHeaderCounter': function (){
      const productsCount = window.listProductsCount;
      var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter");
      if (counter_elem) {
          for (var i = 0; i < counter_elem.length; i++) {
              counter_elem[i].style.display = 'flex';
              const hasProductsInWishlist = productsCount > 0;
              counter_elem[i].classList.toggle('show-badge', hasProductsInWishlist);
              counter_elem[i].innerHTML = productsCount;
          }
      }
  },
  'getListsProducts': async function (swat, lists) {
      return Object.values(
          (
            await Promise.all(
              lists.map(async (list) =>
                swymCustomFunctions.fetchListProductsDetails(swat, list.lid)
              )
            )
          )
          .flat()
          .reduce((acc, { epi, empi, du }) => {
              acc[epi] = { epi, empi, du };
              return acc;
          }, {})
      );
  },
  'getAllProductsWithChannel': async function (swat, lists) {
      // Get all products from all lists with their channel information
      const allProducts = [];
      for (const list of lists) {
          const products = await swymCustomFunctions.fetchListProductsDetails(swat, list.lid);
          products.forEach(product => {
              allProducts.push({
                  ...product,
                  originalLid: list.lid,
                  originalLname: list.lname
              });
          });
      }
      return allProducts;
  },
  'removeProductFromList': async function (swat, lid, product) {
      return new Promise(async (resolve, reject) => {
          swat.deleteFromList(
              lid,
              product,
              result => resolve(result),
              error => reject(error)
          );
      });
  },
  'removeProductsFromListBatch': async function (swat, lid, products) {
      // Remove many products from a list in batches of 10 (API limitation)
      // API reference: https://developers.getswym.com/docs/remove-many-products-from-a-list
      if (!products || products.length === 0) {
          return [];
      }
      
      const BATCH_SIZE = 10;
      const batches = [];
      
      // Split products into batches of 10
      for (let i = 0; i < products.length; i += BATCH_SIZE) {
          batches.push(products.slice(i, i + BATCH_SIZE));
      }
      
      // Process batches sequentially to avoid overwhelming the API
      const results = [];
      for (const batch of batches) {
          try {
              const result = await new Promise((resolve, reject) => {
                  swat.removeProductsFromList(
                      lid,
                      batch,
                      result => resolve(result),
                      error => reject(error)
                  );
              });
              results.push(result);
          } catch (error) {
              console.error('Error removing batch of products from list:', error);
              throw error;
          }
      }
      
      return results.flat();
  },
  'init': async function(swat) {
      try {
          // Validate required global variables
          if (!window.productListTitle || !window.recipeListTitle || !window.blogListTitle) {
              console.error('Swym list titles not configured. Please set window.productListTitle, window.recipeListTitle, and window.blogListTitle');
              return;
          }

          // Track if any modifications were made
          let modificationsMade = false;

          // Define the three required lists
          const requiredLists = [
              { title: window.productListTitle, key: 'productListId', name: 'My wishlist' },
              { title: window.recipeListTitle, key: 'recipeListId', name: 'Recipe list' },
              { title: window.blogListTitle, key: 'blogListId', name: 'Blog list' }
          ];

          // Fetch all existing lists
          let lists = await swymCustomFunctions.fetchLists(swat);

          // Check which required lists exist and create missing ones
          for (const requiredList of requiredLists) {
              const existingList = lists.find(list => 
                  list && list.lname && 
                  list.lname.toLowerCase() === requiredList.title.toLowerCase()
              );

              if (!existingList) {
                  console.log(`List "${requiredList.title}" not found. Creating it.`);
                  await swymCustomFunctions.createList(swat, requiredList.title);
                  modificationsMade = true;
              }
          }

          // Refresh lists after potential creation
          if (modificationsMade) {
              lists = await swymCustomFunctions.fetchLists(swat);
          }

          // Verify all three lists exist and set global variables
          const foundLists = {};
          for (const requiredList of requiredLists) {
              const foundList = lists.find(list => 
                  list && list.lname && 
                  list.lname.toLowerCase() === requiredList.title.toLowerCase()
              );

              if (foundList && foundList.lid) {
                  foundLists[requiredList.key] = foundList.lid;
                  window[requiredList.key] = foundList.lid;
              } else {
                  console.error(`Failed to find or create list: ${requiredList.title}`);
              }
          }

          // Set default active list to product list
          if (foundLists.productListId) {
              window.currentActiveListId = foundLists.productListId;
          }

          console.log('Swym list initialization - SUCCESS', {
              productListId: foundLists.productListId,
              recipeListId: foundLists.recipeListId,
              blogListId: foundLists.blogListId,
              modificationsMade: modificationsMade
          });

          window.recipeProducts = await swymCustomFunctions.fetchListProductsDetails(swat, foundLists.recipeListId);
          window.blogProducts = await swymCustomFunctions.fetchListProductsDetails(swat, foundLists.blogListId);
        
          document.dispatchEvent(new CustomEvent('swym:default-list-executed'));

          swat.ui.open = function(){
              location.href = `${Shopify.routes.root}pages/swym-wishlist`;
          }
      } catch (error) {
          console.error('Error occurred during initialization:', error);
          // Fallback: try to create all three lists
          try {
              await swymCustomFunctions.createList(swat, window.productListTitle);
              await swymCustomFunctions.createList(swat, window.recipeListTitle);
              await swymCustomFunctions.createList(swat, window.blogListTitle);
              // Reload page after fallback list creation
              console.log('Fallback list creation succeeded. Reloading page.');
              window.location.reload();
          } catch (fallbackError) {
              console.error('Fallback list creation also failed:', fallbackError);
          }
      }
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCustomFunctions.init);